import {
    ADD_TRANSLATIONS,
    RESET_TRANSLATIONS
} from "../constans"
import { logError } from "../../utils/builder/IAmecLog"
import { translateExpressions as translateExpressionsIScheduleLogic } from "utils/builder/IScheduleLogic"
export const addTranslationsToState = (translations) => {
    let type = ""
    let payload = {}
    try {
        const dictionary = translations.reduce((acc, item) => {
            acc[item.id] = item.hebrewTranslation
            return acc
        }, {})

        if (Object.keys(dictionary).length > 0) {
            type = ADD_TRANSLATIONS
            payload = dictionary 
        }
        
    } catch (err) {
        logError("FrontEnd.src.store.actions.translations.addTranslationsToState", err.toString())
    } finally {
        return {
            type,
            payload
        }
     }
}
export const translateExpressions = (expressions) => async (dispatch) => {
    try {
        const result = await translateExpressionsIScheduleLogic(expressions)
        dispatch(addTranslationsToState(result))
    } catch (err) {
        logError("FrontEnd.src.store.actions.translations.translateExpressions", err.toString())
    }
}

export const resetTranslations = () => {
    return {
        type: RESET_TRANSLATIONS,
    }
}
